import Api from "@/services/Api";
import SystemConst from "@/config/const";

export default {
  getSalons(query: any) {
    let url = `/users/salon_favorites?page=${query.page}&per_page=${query.per_page}`;
    if (query.salon_genre && query.salon_genre !== SystemConst.SALON_TYPE_ALL) {
      url += `&salon_genre=${query.salon_genre}`;
    }
    return Api().get(url);
  },
  getSalon(salon_id: any) {
    return Api().get(`/users/salon_favorites/${salon_id}`);
  },
  deleteSalon(salon_id: any) {
    return Api().delete(`/users/salon_favorites/${salon_id}`);
  },
  createSalon(params: object) {
    return Api().post(`/users/salon_favorites`, params);
  }
};
